/**
 * abtestid 数据在页面间共享
 * @Author: moonye
 * @Date: 2019-06-20 14:34:45
 * @Last Modified by: moonye
 * @Last Modified time: 2019-09-27 12:06:51
 */

import cookie from '@tencent/im-cookie';
import util from './util';
import { query } from './util.bom';
import injectUtil from './util.inject';

const cookieConfig = {
  name: 'tdw_data_testid',
  domain: 'ke.qq.com',
  path: '/'
};
const REPORT_TESTID_DOM_KEY = 'data-report-testid';

/**
 * 存储的时候使用 # 分隔，在业务或者 tdw 中以分号分隔
 */
export function getTestid() {
  let testid = '';
  try {
    testid = query('url_testid') || cookie.get(cookieConfig.name) || '';
  } catch (e) { }

  setTestid('');
  return testid;
}

function setTestid(ret = '') {
  cookie.setSession(cookieConfig.name, ret, cookieConfig.domain, cookieConfig.path);
}

function clickHandler(finalDom, e) {
  const targetDom = e.target;
  const moduleTarget = util.closest(targetDom, `[${REPORT_TESTID_DOM_KEY}]`);
  const testid = moduleTarget && moduleTarget.getAttribute(REPORT_TESTID_DOM_KEY) || '';
  setTestid(testid);
}

injectUtil.addListener(clickHandler);

